import { createTheme } from "@mui/material";
import { mergeAlpha, mergeBreakpoints, mergeElevation, mergeOverrides, mergePalette, mergeTypography, mergeTypographyOptions, mergeZIndex, } from "../utils";
import { ALPHA_DEFINITIONS } from "./alpha";
import { BREAKPOINT_DEFINITIONS } from "./breakpoints";
import { PALETTE_DEFINITIONS } from "./colors";
import { componentOverrides } from "./components";
import { SHADOW_DEFINITIONS } from "./shadows";
import { DISABLED_MUI_TEXT_DEFINITIONS, TEXT_DEFINITIONS, TEXT_OPTIONS_DEFINITIONS, } from "./text";
import { Z_INDEX_DEFINITIONS } from "./zIndex";
export const THEME_DEFINITIONS = {
    components: componentOverrides(PALETTE_DEFINITIONS, ALPHA_DEFINITIONS),
    typography: {
        ...DISABLED_MUI_TEXT_DEFINITIONS,
        ...TEXT_DEFINITIONS,
    },
    typographyOptions: TEXT_OPTIONS_DEFINITIONS,
    breakpoints: BREAKPOINT_DEFINITIONS,
    palette: PALETTE_DEFINITIONS,
    elevation: SHADOW_DEFINITIONS,
    zIndex: Z_INDEX_DEFINITIONS,
    alpha: ALPHA_DEFINITIONS,
};
/**
 * @description A function that takes a theme, merges it with the base minerva theme, and passes the result through MUI's createTheme function.
 */
export const generateTheme = (theme, baseTheme = THEME_DEFINITIONS) => {
    const { palette, typography, typographyOptions, elevation, zIndex, breakpoints, components, alpha, } = theme;
    return createTheme({
        typography: {
            ...{
                ...mergeTypography(baseTheme.typography, typography),
                ...DISABLED_MUI_TEXT_DEFINITIONS,
            },
            ...mergeTypographyOptions(baseTheme.typographyOptions, typographyOptions),
        },
        components: mergeOverrides(componentOverrides(baseTheme.palette, baseTheme.alpha), components),
        breakpoints: {
            values: mergeBreakpoints(baseTheme.breakpoints, breakpoints),
        },
        palette: mergePalette(baseTheme.palette, palette),
        elevation: mergeElevation(baseTheme.elevation, elevation),
        zIndex: mergeZIndex(baseTheme.zIndex, zIndex),
        alpha: mergeAlpha(baseTheme.alpha, alpha),
        shape: {
            borderRadius: 8,
        },
    });
};
export const theme = generateTheme(THEME_DEFINITIONS);
//# sourceMappingURL=theme.js.map